import httpService from '../../../../services/http.service';
import {
	mockCanSendInvitation,
	mockSendUserInvitations,
	USE_MOCK_INVITE,
} from './InviteUsersDrawer.mock';

export interface CanSendInvitationResult {
	userId: string;
	canSend: boolean;
	reason: string | null;
	/** ISO-8601 date-time of the last invitation sent, null if never sent */
	lastSentAt: string | null;
}

interface InvitationEligibility {
	canSend: boolean;
	reason: string | null;
	lastSentAt: string | null;
}

export interface BulkEligibilityResponse {
	results: Record<string, InvitationEligibility>;
}

export interface BulkSendResponse {
	batchId: string;
	status: string;
	totalQueued: number;
	/** ISO-8601 date-time */
	createdAt: string;
}

/** the response is keyed by userId - flatten it into the row-friendly list the drawer consumes */
const normalize = (
	res: BulkEligibilityResponse | undefined,
): CanSendInvitationResult[] =>
	Object.entries(res?.results ?? {}).map(([userId, result]) => ({
		userId,
		...result,
	}));

/** userIds are legalIds (teudat zeut), taken from the table rows. unitId scopes the check to a business unit. */
export const checkCanSendInvitation = (
	userIds: string[],
	unitId: number,
): Promise<CanSendInvitationResult[]> =>
	(USE_MOCK_INVITE
		? mockCanSendInvitation(userIds)
		: httpService.api<BulkEligibilityResponse>({
				type: 'canSendInvitation',
				params: { unitId },
				data: { userIds },
				disableBI: true,
		  })
	).then(normalize);

/** userIds are legalIds (teudat zeut); unitId scopes the batch to a business unit. */
export const sendUserInvitations = (
	userIds: string[],
	unitId: number,
): Promise<BulkSendResponse> =>
	USE_MOCK_INVITE
		? mockSendUserInvitations()
		: httpService.api<BulkSendResponse>({
				type: 'sendUserInvitations',
				params: { unitId },
				data: { userIds },
				disableBI: true,
		  });

/**
 * httpService rejects with the axios response (which has a numeric status) when
 * the server answered, and with undefined when the request never reached it.
 */
export const isConnectionError = (err: any) =>
	!err || typeof err.status !== 'number';
